import { listingsApi } from "../store/api/listingsApi";
import { runMutation, runQuery, runQueryNoArg } from "../store/api/runtime";
import type { LocationSnapshot } from "../types/location";

interface ApiPayload extends Record<string, unknown> {
  message?: string;
}

export interface ListingItem extends Record<string, unknown> {
  id: string;
  title: string;
  game: string;
  condition: string;
  price: number;
  seller: string;
  ownerId?: string;
  image?: string;
  time?: string;
  listingType?: string;
  location?: LocationSnapshot | null;
  locationPostalCode?: string;
  locationCountryCode?: string;
  locationLabel?: string;
  locationLatitude?: number | null;
  locationLongitude?: number | null;
}

export async function fetchListings(): Promise<ListingItem[]> {
  return runQueryNoArg(listingsApi.endpoints.fetchListings.initiate);
}

export async function fetchListingById(id: string): Promise<ListingItem> {
  return runQuery(listingsApi.endpoints.fetchListingById.initiate, id);
}

export async function fetchMyListings(): Promise<ListingItem[]> {
  return runQueryNoArg(listingsApi.endpoints.fetchMyListings.initiate);
}

export async function createListing(payload: ApiPayload): Promise<unknown> {
  return runMutation(listingsApi.endpoints.createListing.initiate, payload);
}

export async function deleteListingById(id: string): Promise<unknown> {
  return runMutation(listingsApi.endpoints.deleteListingById.initiate, id);
}

export async function updateListingById(id: string, payload: ApiPayload): Promise<unknown> {
  return runMutation(listingsApi.endpoints.updateListingById.initiate, { id, payload });
}

export async function updateListingLocation(id: string, location: LocationSnapshot): Promise<unknown> {
  return runMutation(listingsApi.endpoints.updateListingLocation.initiate, { id, location });
}
